import React from 'react';

const ContactPage = () => {
  return (
    <div className="max-w-[960px] mx-auto px-5 sm:px-6 md:px-10 py-20 text-[#2A2A2A] font-['Helvetica Neue','Helvetica','Arial',sans-serif]">
      <h1 className="text-[28px] leading-10 tracking-[.12em] uppercase font-normal text-center mb-10">
        Contact Us
      </h1>

      <div className="text-[15px] leading-[30px] font-light tracking-wide space-y-6 text-center">
        <p>
          We’re here to help with any questions or inquiries.
        </p>

        <div className="space-y-4">
          <p>
            <strong>WhatsApp:</strong> <a href="https://wa.me/9647514141213" target="_blank" rel="noopener noreferrer" className="underline hover:text-black">
              +964 751 414 1213
            </a><br />
            <span className="text-sm text-gray-600">(We usually respond immediately)</span>
          </p>

          <p>
            <strong>Email:</strong> <a href="mailto:info@mory-gold.com" className="underline hover:text-black">
              info@mory-gold.com
            </a><br />
            <span className="text-sm text-gray-600">(Emails are typically replied to within 24 hours)</span>
          </p>
        </div>

        <p>
          Whether it’s a question about our collections, custom designs, or your order — don’t hesitate to reach out.
        </p>
      </div>
    </div>
  );
};

export default ContactPage;
